import { MOVE_TO_CONTENT_FOLDER_SUCCESS } from "fleet/redux-store/content-folders/actions";
import reduceReducers from "reduce-reducers";
import { getApiReducer } from "redux-store/api-sagas";
import { reduceById, updateById } from "redux-store/reducers";

import {
  ARCHIVE_USER_CONTENTS_SUCCESS,
  LOAD_USER_CONTENTS,
  LOAD_USER_CONTENTS_FAILURE,
  UPLOAD_USER_CONTENT_SUCCESS,
  EDIT_USER_CONTENT_SUCCESS,
} from "./actions";

const userContentsLoadReducer = getApiReducer(
  LOAD_USER_CONTENTS,
  LOAD_USER_CONTENTS_FAILURE,
);

function userContentsUpdateReducer(state = {}, action) {
  const { payload, type } = action;

  switch (type) {
    case ARCHIVE_USER_CONTENTS_SUCCESS:
      return {
        ...state,
        byId: {
          ...reduceById(state.byId, payload.data),
        },
      };
    case EDIT_USER_CONTENT_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.data.id]: payload.data,
        },
      };
    case MOVE_TO_CONTENT_FOLDER_SUCCESS:
      return {
        ...state,
        byId: {
          ...reduceById(state.byId, payload.data.contents),
        },
      };
    default:
      return state;
  }
}

function userContentCreateReducer(state = {}, action) {
  const { payload, type } = action;
  switch (type) {
    case UPLOAD_USER_CONTENT_SUCCESS:
      return {
        ...state,
        byId: {
          ...updateById(state.byId, payload.data),
        },
      };
    default:
      return state;
  }
}

const userContentsReducer = reduceReducers(
  userContentCreateReducer,
  userContentsLoadReducer,
  userContentsUpdateReducer,
);

export { userContentsReducer };
